import './GenericLoader.css';
export default {
    "skeletonContainer": "GenericLoader_skeletonContainer__m5nj2",
    "skeletonBox": "GenericLoader_skeletonBox__m5nj2",
    "box1": "GenericLoader_box1__m5nj2",
    "fadeBox1": "GenericLoader_fadeBox1__m5nj2",
    "box2": "GenericLoader_box2__m5nj2",
    "fadeBox2": "GenericLoader_fadeBox2__m5nj2",
    "box3": "GenericLoader_box3__m5nj2",
    "fadeBox3": "GenericLoader_fadeBox3__m5nj2"
};
